import React from 'react';
import AnalyticsDashboard from '../../components/learning/AnalyticsDashboard';
import styles from './AnalyticsPage.module.css';

/**
 * AnalyticsPage
 * 
 * Displays learning analytics and performance metrics for the agent.
 * Provides a comprehensive view of the user's learning progress and memory retention.
 * Themed to resemble Cold War era intelligence reports.
 */
const AnalyticsPage: React.FC = () => {
  return (
    <div className={styles.container} data-testid="analytics-page">
      <header className={styles.pageHeader}>
        <div>
          <h1 className={styles.title}>
            <span className={styles.titleIcon}>📊</span>
            Field Intelligence Report
          </h1>
          <p className={styles.subtitle}>
            Operational memory and skills assessment
          </p>
        </div>
      </header>
      
      <AnalyticsDashboard />
    </div>
  );
};

export default AnalyticsPage; 